import { MapExtent } from './GisTypes';

export const getCentroid = ({ ymax, ymin, xmax, xmin }: MapExtent): [number, number] => {
  const centerLat = (ymax + ymin) / 2;
  const centerLng = (xmax + xmin) / 2;

  return [centerLat, centerLng];
};
